import React, { Component } from 'react';
import { connect } from 'react-redux';
import { initApp, authFieldChanged, registerUser, authUnload, startRedirect, toggleCopy, getTeamInfo } from '../../actions';
import { Link, withRouter } from 'react-router-dom'
import { IconInput, Spinner, Error } from '../common';
import HowItWorks from './HowItWorks';
import Pricing from './Pricing';
import Systematize from './Systematize';
import Intercom from 'react-intercom';

class GetStarted extends Component {

  constructor(props){
    super(props);
    this.state = {
      get_info: false
    }
  }

  componentWillMount() {
    if(!this.props.init){
      this.props.initApp("get_started");
    }
    const id = this.props.match.params.id;
    if(id){
      this.props.getTeamInfo({id});
      //this.props.startRedirect("https://dealmachine.com/team/"+id);
    }else{
      this.props.startRedirect("https://dealmachine.com/");
    }

  }
  componentWillUpdate(newProps){

    if(this.props.team != newProps.team){
      if(newProps.team.live_page){
        if(newProps.team.live_page == 1){
          const id = this.props.match.params.id;
          if(id){
            this.props.startRedirect("https://dealmachine.com/team/"+id);
          }else{
            this.props.startRedirect("https://dealmachine.com/");

          }
        }else{
          this.setState({got_info: true})

        }

      }else{
        this.setState({got_info: true})
      }
    }
  }

  goToLogin(){
    this.props.startRedirect("https://dealmachine.com/login");
  }

  submitForm = (ev) =>{
    ev.preventDefault();
    const { email, password, firstname, lastname, team, from_campaign, from_source, branch_id } = this.props;
    this.props.registerUser({ email, password, firstname, lastname, team_id: team.id, from_campaign, from_source, branch_id });
  }

  renderSpinner(){
    if(this.props.loading){
      return <Spinner />
    }
  }


  renderError(){
    if(this.props.error){
      return <Error text={this.props.error}/>
    }
  }

  handleTab(tab){
    this.props.toggleCopy(tab);
    //scroll down
    var elem = document.getElementById('get-started-info-container');
    var container = document.getElementById('leftContainer');
    container.scrollTo(0, elem.offsetTop - 160);


  }

  renderTeamName(){
    if(this.props.team){
      if(this.props.team.company && this.props.team.company !== ""){
        return this.props.team.company;
      }else{
        return this.props.team.firstname+" "+this.props.team.lastname;
      }
    }
    return "";
  }

  render() {
    if(this.props.init && this.props.team && this.state.got_info){
      return (
        <div className="fill-background">

          <Intercom appID="sfur1js7" />

          <div className="dm-navbar">
            <div className="dm-navbar-button-wrapper">
              <div className="dm-navbar-button dm-logo">
                <img alt="" src="/assets/images/Icon-white.png" />
              </div>
            </div>
            <div className="dm-navbar-title">
              <div className="dm-navbar-title-text">
                Step 1 of 3
              </div>

              <div className="dm-navbar-subtitle">
                Create your account
              </div>
            </div>

            <div className="dm-navbar-button-wrapper" style={{marginRight: 15}}>
              {/*
              <a role="button" onClick={this.goToLogin.bind(this)} className="dm-navbar-button" >

                <div className="dm-navbar-title-text">
                  Login
                </div>
              </a>
              */}
            </div>


          </div>
          <div className="fill-background">
          <div className="dm-get-started-wrapper ">





            <div id="leftContainer" className='dm-get-started-right scroll-me' ref="leftContainer">
              <div className="video-container">
                <div className='video-wrapper'>
                  <video className="dm-background-video" loop autoPlay>
                      <source src="/assets/videos/video.mp4" type="video/mp4" />
                      <source src="/assets/videos/video.oggtheora.ogv" type="video/ogv" />
                      <source src="/assets/videos/video.webmhd.webm" type="video/webm" />
                  </video>
                </div>

                <div className="video-inner">
                  <div className="video-inner-container">
                    <h3 className='video-h1'>
                      <strong>Get Paid</strong> to<br />Explore<strong> Your City</strong>
                    </h3>
                    <h3 className='video-h2'>Earn up to $20 / hour while exploring your city by taking<br /> a photo when you see a home in need of repair.</h3>
                    <p style={{color:"#fff"}}>This DealMachine Site is hosted for <b>{this.renderTeamName()}</b></p>
                  </div>
                </div>

                <div className="video-buttons">

                  <button className={this.props.copy_tab == "how_it_works" ? 'video-button active' : "video-button"} onClick={this.handleTab.bind(this, "how_it_works")}>
                    <div className='video-button-icon'>
                      <i className="material-icons">help</i>
                    </div>
                    <div className='video-button-text'>
                      How It Works
                    </div>
                  </button>



                  <button className={this.props.copy_tab == "pricing" ? 'video-button active' : "video-button"} onClick={this.handleTab.bind(this, "pricing")}>
                    <div className='video-button-icon'>
                      <i className="material-icons">camera_alt</i>
                    </div>
                    <div className='video-button-text'>
                      Why Take Pictures?
                    </div>
                  </button>

                  <button className={this.props.copy_tab == "systematize" ? 'video-button active' : "video-button"} onClick={this.handleTab.bind(this, "systematize")}>
                    <div className='video-button-icon'>
                      <i className="material-icons">playlist_add_check</i>
                    </div>
                    <div className='video-button-text'>
                      Requirements
                    </div>
                  </button>


                </div>


              </div>
              <div id="get-started-info-container" className="get-started-info-container">
                <HowItWorks />
                <Pricing />
                <Systematize />

              </div>


            </div>
            <div className='dm-get-started-left flex-item scroll-me'>
              <div className="dm-get-started-left-inner">
                <div className="card-body">
                  <h1>Start Earning Today</h1>
                  <p> Join 6,000 people who earn extra money on their own schedule.</p>
                </div>


                    <form
                      className=""
                      onSubmit={this.submitForm.bind(this)}
                    >

                          <div className="flex-item">
                            <div className="double-input">
                              <IconInput
                                label="First Name"
                                value={this.props.firstname}
                                onChange={ ev => this.props.authFieldChanged({ prop: "firstname", value: ev.target.value })}
                                type={"text"}
                                icon={"account_circle"}
                              />
                              <IconInput
                                style={{borderLeftWidth: 1, borderLeftColor: "#eee", borderLeftStyle: "solid"}}
                                label="Last Name"
                                value={this.props.lastname}
                                onChange={ ev => this.props.authFieldChanged({ prop: "lastname", value: ev.target.value })}
                                type={"text"}
                                icon={""}
                              />
                            </div>


                          </div>

                          <div className="flex-item">
                            <IconInput
                              label="Email Address"
                              value={this.props.email}
                              editable={this.props.signup_type == "team_invite" ? false : true}
                              onChange={ ev => this.props.authFieldChanged({ prop: "email", value: ev.target.value })}
                              type={"email"}
                              icon={"email"}
                            />
                            <IconInput
                              label="Password"
                              value={this.props.password}
                              onChange={ ev => this.props.authFieldChanged({ prop: "password", value: ev.target.value })}
                              type={"password"}
                              icon={"lock"}
                            />
                          </div>

                          <div style={{padding: 20}}>
                            <div className="flex-item">
                              <button
                                type="submit"
                                className="flex-item primary-button"
                              >

                                  Get Started
                              </button>
                            </div>
                            {/*
                            <div style={{paddingTop:20, paddingBottom:20}}>
                              <a role="button" onClick={this.goToLogin.bind(this)}>
                                Already have an account?
                              </a>

                            </div>
                            */}
                          </div>
                          {/*
                          <div className="dm-card-bottom">
                            <div className="card-body">
                              <div className="dm-testimonial">

                                  <div className="dm-testimonial-image">
                                    <img src="/assets/images/peter_stanley.jpg" />
                                  </div>


                                  <div className="dm-testimonial-info">
                                      <div className="dm-testimonial-quote">
                                        “This app is awesome. No more writing addresses on the back of Chick-fil-A bags that never get mailed to.”
                                      </div>
                                      <div className="dm-testimonial-stars">
                                        <i className="material-icons">star</i><i className="material-icons">star</i><i className="material-icons">star</i><i className="material-icons">star</i><i className="material-icons">star</i>
                                      </div>
                                      <div className="dm-testimonial-name">
                                        <strong>- Peter Stanley</strong><br /> Acacia Group Homes, Charleston, SC
                                      </div>

                                  </div>

                              </div>
                            </div>

                          </div>
                          */}
                    </form>


              </div>



            </div>

          </div>

        </div>

          {this.renderSpinner()}
          {this.renderError()}
        </div>
      );
    }else{
      return (
        <div>
          <Spinner />
        </div>
      );
    }
  }
};

const mapStateToProps = ({ auth }) => {
  const { token, init, copy_tab, team, team_loading, team_error, email, password, firstname, lastname, company, promoText, from_campaign, from_source, error, loading, signup_type, signup_team_name, signup_team_company, partner, partner_logo, partner_logo_white } = auth;
  return { token, init, copy_tab, team, team_loading, team_error, email, password, firstname, lastname, company, promoText, from_campaign, from_source, error, loading, signup_type, signup_team_name, signup_team_company, partner, partner_logo, partner_logo_white }
}

export default withRouter(connect(mapStateToProps, { initApp, authFieldChanged, registerUser, authUnload, startRedirect, toggleCopy, getTeamInfo })(GetStarted));



// WEBPACK FOOTER //
// ./src/components/GetStarted/index.js